export const MODAL_RESPONSE_TYPE = {
  ACCEPT: 'accept',
  REJECT: 'reject',
  CLOSE: 'close',
};
